import React from 'react'
import { Typography } from '@material-ui/core'
import { Trans } from 'react-i18next'

const TermsAndConditions = props => {
  return <Typography variant='body2' component='a' href='/terms' target='_blank' align='center'>
    <Trans i18nKey='termsAndConditions'/>
  </Typography>
}

export default TermsAndConditions
